import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom"; // 👈 add this
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";
import ConfirmModal from "../../components/ConfirmModal";
import {enterEditMode} from "./helpers";

const WaiverActionsDropdown = ({
  waiver,
  newVersionWaiver,
  isOpen,
  setOpenDropdownId,
  onEdit,
  onDisable,
}) => {
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const isPublished = waiver.waiverStatus === "published";
  const isArchived =
  waiver.waiverStatus === "archived_by_admin" ||
  waiver.waiverStatus === "archived_by_new_version" ||
  waiver.waiverStatus === "archived_by_location_deletion";
  const { business } = useBusinessAuthContext();

  const [showDiscardConfirm, setShowDiscardConfirm] = useState(false);
  const [creatingVersion, setCreatingVersion] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, [setOpenDropdownId]);

  
  const handleToggle = (e) => {
    e.stopPropagation();
    setOpenDropdownId(isOpen ? null : waiver._id);
  };

  const handleDiscardDraft = async () => {
    try {
      const res = await fetch(
        `${API_URL.BUSINESS_DISCARD_NEW_VERSION}/${newVersionWaiver._id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${business.token}`,
            "x-session-id": business.sessionId,
            "x-frontend-url": window.location.pathname,
          },
        }
      );

      const data = await res.json();

      if (data.success) {
        window.location.reload();
      } else {
        alert(data.message || "Failed to discard draft");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setShowDiscardConfirm(false);
    }
  };

  return (
    <>
    <div className="relative" ref={dropdownRef}>
      {!isArchived && (
        <button onClick={handleToggle} className="text-gray-600">
          ⋮
        </button>
      )}

      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-lg border z-[999]">

          {/* ✅ Show Preview only if fully completed and published */}
          {/* Archived → only View */}
          {/*  isArchived ? (
            <button
              onClick={() => {
                setOpenDropdownId(null);
                navigate(`/business/waiverviewer/${waiver._id}`);
              }}
              className="block w-full text-left px-4 py-2 hover:bg-gray-50"
            >
              View
            </button>
          ) : */} { isPublished ? (
            <button
              onClick={() => {
                setOpenDropdownId(null);
                navigate(`/business/waiverbuilder/smart/${waiver._id}/step-7`);
              }}
              className="block w-full text-left px-4 py-2 hover:bg-gray-50"
            >
              Preview Live Waiver
            </button>
          ) : (
            <button
              onClick={async () => {
              setOpenDropdownId(null);

              if (!(await enterEditMode(waiver, business))) return;

              onEdit();
            }}
              className="block w-full text-left px-4 py-2 hover:bg-gray-50"
            >
              Edit Draft
            </button>
          )}

          {/* ✅ Versioning action for published waiver */}
          {isPublished && !isArchived && (
            <button
              onClick={async () => {
              setOpenDropdownId(null);

              // If version already exists → edit it
              if (newVersionWaiver) {
                if (!(await enterEditMode(newVersionWaiver, business))) return;
                
                navigate(`/business/waivereditor/${newVersionWaiver._id}`);
                //navigate(`/business/waiverbuilder/smart/${newVersionWaiver._id}/step-3`);
                return;
              }

              try {

                if (creatingVersion) return;
                setCreatingVersion(true);

                const res = await fetch(
                  `${API_URL.BUSINESS_CREATE_NEW_VERSION}/${waiver._id}`,
                  {
                    method: "PATCH",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${business.token}`,
                      "x-session-id": business.sessionId,
                      "x-frontend-url": window.location.pathname,
                    },
                  }
                );

                const data = await res.json();
                
                if (data.success) {
                 //  await enterEditMode(data.newVersionWaiverId); //waiver object to be passed. However, no need as new version is always set to EditWizard, notCreate
                  /*navigate(
                    `/business/waiverbuilder/smart/${data.newVersionWaiverId}/step-3`
                  );*/
                  navigate(`/business/waivereditor/${data.newVersionWaiverId}`);
                } else {
                   alert(data.message || "Cannot create new version");
                }
              } catch (err) {
                console.error(err);
                alert("Server error");
              } finally {
                  setCreatingVersion(false);
              }
            }}
            className={`block w-full text-left px-4 py-2 ${
              creatingVersion
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-gray-50"
            }`}
            disabled={creatingVersion}
            >
              {
                creatingVersion
                  ? "Creating New Version..."
                  : newVersionWaiver
                    ? "Continue Editing"
                    : "Edit Waiver"
              }
            </button>
          )}

          {isPublished && !isArchived && newVersionWaiver && (
            <button
              onClick={() => {
                setOpenDropdownId(null);
                setShowDiscardConfirm(true);
              }}
              className="block w-full text-left px-4 py-2 hover:bg-gray-50 text-red-500"
            >
              Discard Draft
            </button>
          )}

          {/* Disable only if NOT archived */}
          {!isArchived && (
            <button
              onClick={onDisable}
              className="block w-full text-left px-4 py-2 hover:bg-gray-50 text-red-500"
            >
              Archive Waiver
            </button>
          )}          
         
        </div>
      )}
    </div>
    
      {showDiscardConfirm && (
        <ConfirmModal
          open={showDiscardConfirm}
          title="Discard Draft"
          message="Are you sure you want to discard this draft version? Any unpublished changes will be permanently lost."
          confirmText="Discard Draft"
          cancelText="Cancel"
          onConfirm={handleDiscardDraft}
          onCancel={() => setShowDiscardConfirm(false)}
        />
      )}

    </>
  );
};

export default WaiverActionsDropdown;